<template>
    <basic-modal @hide="close"
                 v-model="opened"
                 aria-label="Crop Picture Dialog"
                 role="dialog"
    >
        <template #header>
            <div>
                <basic-modal-close-button ref="closeButton"></basic-modal-close-button>
                <h3 class="modal-title">{{ title }}</h3>
            </div>
        </template>
        <Cropper
                v-if="opened && image"
                ref="cropper"
                class="cropper"
                :stencil-component="stencilComponent"
                :stencil-props="stencilProps"
                :src="image"
                :max-width="4800"
                :max-height="4800"
                :canvas="canvasOptions"
        ></Cropper>

        <template #footer>
            <div>
                <div class="row">
                    <div class="col-sm-5 text-left">
                        <vue-switch-with-label :collapse-on-mobile="false" name="save_to_media" v-model="saveToMedia"
                                               label="Save to My Media"
                                               v-if="allowSaveToMedia"></vue-switch-with-label>
                    </div>
                    <div class="col-sm-7 text-right">
                        <button
                                type="button" @click="close()"
                                class="btn btn-mm
                                 btn-primary"
                        >Cancel
                        </button>
                        <button
                                type="button"
                                ref="selectButton"
                                @click="select()"
                                @keydown.tab.stop.prevent="focusToClose"
                                class="btn btn-mm  btn-green"
                        >Select
                        </button>
                    </div>
                </div>

            </div>
        </template>
    </basic-modal>
</template>

<script>
    import {Cropper, CircleStencil, RectangleStencil} from 'vue-advanced-cropper';
    // vue-advanced-cropper 2 ships its stylesheet as a file rather than injecting it from
    // the bundle the way 0.16 did - without this the cropper renders unstyled
    import 'vue-advanced-cropper/dist/style.css';
    import BasicModal from "../../../vue/common_components/BasicModal";
    import PopupPromiseMixin from "../../../vue/mixins/PopupPromiseMixin";
    import {MAX_IMAGE_SIDE, cropToDataUrl, downscaleImage} from "./cropImageSize";

    export default {
        components: {BasicModal, Cropper},
        mixins: [PopupPromiseMixin],
        data() {
            return {
                title: undefined,
                opened: false,
                image: undefined,
                rectangle: false,
                stencilProps: {},
                allowSaveToMedia: false,
                saveToMedia: true,
                // remote sources aren't downscaled up front, so cap the crop as well
                canvasOptions: {maxWidth: MAX_IMAGE_SIDE, maxHeight: MAX_IMAGE_SIDE},
            };
        },
        computed: {
            firstFocusEl() {
                return this.$refs.selectButton;
            },
            /**
             * Which stencil to hand the cropper, worked out here rather than held in `data`.
             *
             * A component option object put into `data` is made reactive, and vue 3 warns
             * about ("Vue received a Component that was made a reactive object") and proxies
             * it - a computed hands the raw component over untouched.
             */
            stencilComponent() {
                return this.rectangle ? RectangleStencil : CircleStencil;
            }
        },
        methods: {
            setInitial(image, title = 'Avatar', rectangle = false, allowSaveToMedia = false, stencilProps={}) {

                // const getBase64FromImageUrl = (url) => {
                //     const img = new Image();
                //     const vm = this;
                //     img.setAttribute('crossOrigin', 'anonymous');
                //     img.onload = function() {
                //         const canvas = document.createElement("canvas");
                //         canvas.width = this.width;
                //         canvas.height = this.height;
                //
                //         const ctx = canvas.getContext("2d");
                //         ctx.drawImage(this, 0, 0);
                //         const dataURL = canvas.toDataURL("image/png");
                //         vm.image = dataURL;
                //         vm.opened = true;
                //     };
                //     img.src = url;
                // };

                this.allowSaveToMedia = allowSaveToMedia;
                this.rectangle = rectangle;
                if (rectangle) {
                    this.stencilProps = stencilProps;
                }
                this.title = title;

                // const isDataUrl = image.startsWith('data:');
                // if (isDataUrl) {
                this.image = undefined;
                this.pendingImage = image;
                downscaleImage(image).then(src => {
                    // the popup may have been reused for another picture meanwhile
                    if (this.pendingImage === image) {
                        this.image = src;
                    }
                });
                this.opened = true;
                // } else {
                //     getBase64FromImageUrl(image);
                // }
            },
            select() {
                const {canvas} = this.$refs.cropper.getResult();
                const imageToUpload = cropToDataUrl(canvas);
                this.save({
                    avatarBase64value: imageToUpload,
                    saveToMedia: this.saveToMedia && this.allowSaveToMedia
                });
            }
        },
        name: "AvatarCropPopup"
    };
</script>

<style scoped>
    .cropper {
        /*border: solid 1px #EEE;*/
        height: 350px;
        width: 100%;
    }
</style>
